"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getImagesToPreload: true,
  assets: true,
  Router: true,
  BlockWithLeftIcon: true,
  Bottom: true,
  Button: true,
  ClosableInput: true,
  Container: true,
  Divider: true,
  Element: true,
  ElementGroup: true,
  HighligthedText: true,
  Icon: true,
  KeyValueElement: true,
  LinkButton: true,
  ListSelect: true,
  LoadingPlaceHolder: true,
  Page: true,
  PaymentIcon: true,
  PlaceHolderElement: true,
  ResponsivePage: true,
  RightPaneWidgetFrame: true,
  Spacer: true,
  SquaredText: true,
  Subtitle: true,
  Title: true,
  TitleBlock: true,
  TitledContainer: true,
  Top: true,
  TopBar: true,
  AddPassengerRightPane: true,
  AddPassengerWidget: true,
  AddressFormComponent: true,
  BillingDetailsWidget: true,
  BookingForm: true,
  CitySelectionWidget: true,
  CovidInfoWidget: true,
  DateSelectionComponent: true,
  DateSelectionWidget: true,
  DefaultScreen: true,
  EditPassengerForm: true,
  EditPassengerFormUI: true,
  HomeTopBar: true,
  LoadingScreen: true,
  OrderPriceDetails: true,
  PassengerDetails: true,
  PlaceHolder: true,
  PopupField: true,
  PopupScreen: true,
  ResponsiveCentralPaneWrapper: true,
  RidesList: true,
  RidesListItem: true,
  SeatMatrix: true,
  SeatMatrixFloorSelector: true,
  SeatMatrixLegend: true,
  SeatSelectionWidget: true,
  SelectedPassengers: true,
  TicketDetails: true,
  TicketDetailsContent: true,
  TripPriceDetails: true,
  TripSeatDetails: true,
  BoardingPass: true,
  SignInOrSignUpPageUI: true,
  BookingFormPage: true,
  DateSelectionPopup: true,
  GenericTripsListPage: true,
  GenericTripsDetailsPage: true,
  GenericTripSeatSelectionPage: true,
  GenericStopsPage: true,
  PassengerDetailsPage: true,
  PassengerDetailsAddPage: true,
  BillingDetailsPage: true,
  CovidInfoPage: true,
  OrderSetupPage: true,
  PaymentPage: true,
  ProcessingPaymentPage: true,
  BookingErrorPage: true,
  BookingConfirmedPage: true,
  EmptyOrdersPage: true,
  OrdersPage: true,
  TicketPage: true,
  TicketBoardingPassPage: true,
  TicketNotFoundPage: true,
  WelcomePage: true,
  ForgotPasswordLinkSentPage: true,
  ForgotPasswordPage: true,
  LoginPage: true,
  LoggingInPage: true,
  SignUpPage: true,
  SignUpOkPage: true,
  SettingsPage: true,
  LanguageSettingsPage: true,
  EditPassengersPage: true,
  EditPassengerPopup: true,
  AddPassengerPopup: true,
  BetaOnboardingCarousselPage: true,
  BetaOnboardingWaitingPage: true
};
exports.getImagesToPreload = getImagesToPreload;
Object.defineProperty(exports, "BlockWithLeftIcon", {
  enumerable: true,
  get: function get() {
    return _BlockWithLeftIcon["default"];
  }
});
Object.defineProperty(exports, "Bottom", {
  enumerable: true,
  get: function get() {
    return _Bottom["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});
Object.defineProperty(exports, "ClosableInput", {
  enumerable: true,
  get: function get() {
    return _ClosableInput["default"];
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});
Object.defineProperty(exports, "Divider", {
  enumerable: true,
  get: function get() {
    return _Divider["default"];
  }
});
Object.defineProperty(exports, "Element", {
  enumerable: true,
  get: function get() {
    return _Element["default"];
  }
});
Object.defineProperty(exports, "ElementGroup", {
  enumerable: true,
  get: function get() {
    return _ElementGroup["default"];
  }
});
Object.defineProperty(exports, "HighligthedText", {
  enumerable: true,
  get: function get() {
    return _HighligthedText["default"];
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});
Object.defineProperty(exports, "KeyValueElement", {
  enumerable: true,
  get: function get() {
    return _KeyValueElement["default"];
  }
});
Object.defineProperty(exports, "LinkButton", {
  enumerable: true,
  get: function get() {
    return _LinkButton["default"];
  }
});
Object.defineProperty(exports, "ListSelect", {
  enumerable: true,
  get: function get() {
    return _ListSelect["default"];
  }
});
Object.defineProperty(exports, "LoadingPlaceHolder", {
  enumerable: true,
  get: function get() {
    return _LoadingPlaceHolder["default"];
  }
});
Object.defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return _Page["default"];
  }
});
Object.defineProperty(exports, "PaymentIcon", {
  enumerable: true,
  get: function get() {
    return _PaymentIcon["default"];
  }
});
Object.defineProperty(exports, "PlaceHolderElement", {
  enumerable: true,
  get: function get() {
    return _PlaceHolderElement["default"];
  }
});
Object.defineProperty(exports, "ResponsivePage", {
  enumerable: true,
  get: function get() {
    return _ResponsivePage["default"];
  }
});
Object.defineProperty(exports, "RightPaneWidgetFrame", {
  enumerable: true,
  get: function get() {
    return _RightPaneWidgetFrame["default"];
  }
});
Object.defineProperty(exports, "Spacer", {
  enumerable: true,
  get: function get() {
    return _Spacer["default"];
  }
});
Object.defineProperty(exports, "SquaredText", {
  enumerable: true,
  get: function get() {
    return _SquaredText["default"];
  }
});
Object.defineProperty(exports, "Subtitle", {
  enumerable: true,
  get: function get() {
    return _Subtitle["default"];
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _Title["default"];
  }
});
Object.defineProperty(exports, "TitleBlock", {
  enumerable: true,
  get: function get() {
    return _TitleBlock["default"];
  }
});
Object.defineProperty(exports, "TitledContainer", {
  enumerable: true,
  get: function get() {
    return _TitledContainer["default"];
  }
});
Object.defineProperty(exports, "Top", {
  enumerable: true,
  get: function get() {
    return _Top["default"];
  }
});
Object.defineProperty(exports, "TopBar", {
  enumerable: true,
  get: function get() {
    return _TopBar["default"];
  }
});
Object.defineProperty(exports, "AddPassengerRightPane", {
  enumerable: true,
  get: function get() {
    return _AddPassengerRightPane["default"];
  }
});
Object.defineProperty(exports, "AddPassengerWidget", {
  enumerable: true,
  get: function get() {
    return _AddPassengerWidget["default"];
  }
});
Object.defineProperty(exports, "AddressFormComponent", {
  enumerable: true,
  get: function get() {
    return _AddressFormComponent["default"];
  }
});
Object.defineProperty(exports, "BillingDetailsWidget", {
  enumerable: true,
  get: function get() {
    return _BillingDetailsWidget["default"];
  }
});
Object.defineProperty(exports, "BookingForm", {
  enumerable: true,
  get: function get() {
    return _BookingForm["default"];
  }
});
Object.defineProperty(exports, "CitySelectionWidget", {
  enumerable: true,
  get: function get() {
    return _CitySelectionWidget["default"];
  }
});
Object.defineProperty(exports, "CovidInfoWidget", {
  enumerable: true,
  get: function get() {
    return _CovidInfoWidget["default"];
  }
});
Object.defineProperty(exports, "DateSelectionComponent", {
  enumerable: true,
  get: function get() {
    return _DateSelectionComponent["default"];
  }
});
Object.defineProperty(exports, "DateSelectionWidget", {
  enumerable: true,
  get: function get() {
    return _DateSelectionWidget["default"];
  }
});
Object.defineProperty(exports, "DefaultScreen", {
  enumerable: true,
  get: function get() {
    return _DefaultScreen["default"];
  }
});
Object.defineProperty(exports, "EditPassengerForm", {
  enumerable: true,
  get: function get() {
    return _EditPassengerForm["default"];
  }
});
Object.defineProperty(exports, "EditPassengerFormUI", {
  enumerable: true,
  get: function get() {
    return _EditPassengerFormUI["default"];
  }
});
Object.defineProperty(exports, "HomeTopBar", {
  enumerable: true,
  get: function get() {
    return _HomeTopBar["default"];
  }
});
Object.defineProperty(exports, "LoadingScreen", {
  enumerable: true,
  get: function get() {
    return _LoadingScreen["default"];
  }
});
Object.defineProperty(exports, "OrderPriceDetails", {
  enumerable: true,
  get: function get() {
    return _OrderPriceDetails["default"];
  }
});
Object.defineProperty(exports, "PassengerDetails", {
  enumerable: true,
  get: function get() {
    return _PassengerDetails["default"];
  }
});
Object.defineProperty(exports, "PlaceHolder", {
  enumerable: true,
  get: function get() {
    return _PlaceHolder["default"];
  }
});
Object.defineProperty(exports, "PopupField", {
  enumerable: true,
  get: function get() {
    return _PopupField["default"];
  }
});
Object.defineProperty(exports, "PopupScreen", {
  enumerable: true,
  get: function get() {
    return _PopupScreen["default"];
  }
});
Object.defineProperty(exports, "ResponsiveCentralPaneWrapper", {
  enumerable: true,
  get: function get() {
    return _ResponsiveCentralPaneWrapper["default"];
  }
});
Object.defineProperty(exports, "RidesList", {
  enumerable: true,
  get: function get() {
    return _RidesList["default"];
  }
});
Object.defineProperty(exports, "RidesListItem", {
  enumerable: true,
  get: function get() {
    return _RidesListItem["default"];
  }
});
Object.defineProperty(exports, "SeatMatrix", {
  enumerable: true,
  get: function get() {
    return _SeatMatrix["default"];
  }
});
Object.defineProperty(exports, "SeatMatrixFloorSelector", {
  enumerable: true,
  get: function get() {
    return _SeatMatrixFloorSelector["default"];
  }
});
Object.defineProperty(exports, "SeatMatrixLegend", {
  enumerable: true,
  get: function get() {
    return _SeatMatrixLegend["default"];
  }
});
Object.defineProperty(exports, "SeatSelectionWidget", {
  enumerable: true,
  get: function get() {
    return _SeatSelectionWidget["default"];
  }
});
Object.defineProperty(exports, "SelectedPassengers", {
  enumerable: true,
  get: function get() {
    return _SelectedPassengers["default"];
  }
});
Object.defineProperty(exports, "TicketDetails", {
  enumerable: true,
  get: function get() {
    return _TicketDetails["default"];
  }
});
Object.defineProperty(exports, "TicketDetailsContent", {
  enumerable: true,
  get: function get() {
    return _TicketDetailsContent["default"];
  }
});
Object.defineProperty(exports, "TripPriceDetails", {
  enumerable: true,
  get: function get() {
    return _TripPriceDetails["default"];
  }
});
Object.defineProperty(exports, "TripSeatDetails", {
  enumerable: true,
  get: function get() {
    return _TripSeatDetails["default"];
  }
});
Object.defineProperty(exports, "BoardingPass", {
  enumerable: true,
  get: function get() {
    return _BoardingPass["default"];
  }
});
Object.defineProperty(exports, "SignInOrSignUpPageUI", {
  enumerable: true,
  get: function get() {
    return _SignInOrSignUpPageUI["default"];
  }
});
Object.defineProperty(exports, "BookingFormPage", {
  enumerable: true,
  get: function get() {
    return _BookingFormPage["default"];
  }
});
Object.defineProperty(exports, "DateSelectionPopup", {
  enumerable: true,
  get: function get() {
    return _b_DateSelectionPopup["default"];
  }
});
Object.defineProperty(exports, "GenericTripsListPage", {
  enumerable: true,
  get: function get() {
    return _GenericTripsListPage["default"];
  }
});
Object.defineProperty(exports, "GenericTripsDetailsPage", {
  enumerable: true,
  get: function get() {
    return _GenericTripsDetailsPage["default"];
  }
});
Object.defineProperty(exports, "GenericTripSeatSelectionPage", {
  enumerable: true,
  get: function get() {
    return _b_GenericTripSeatSelectionPage["default"];
  }
});
Object.defineProperty(exports, "GenericStopsPage", {
  enumerable: true,
  get: function get() {
    return _c_GenericStopsPage["default"];
  }
});
Object.defineProperty(exports, "PassengerDetailsPage", {
  enumerable: true,
  get: function get() {
    return _PassengerDetailsPage["default"];
  }
});
Object.defineProperty(exports, "PassengerDetailsAddPage", {
  enumerable: true,
  get: function get() {
    return _PassengerDetailsAddPage["default"];
  }
});
Object.defineProperty(exports, "BillingDetailsPage", {
  enumerable: true,
  get: function get() {
    return _BillingDetailsPage["default"];
  }
});
Object.defineProperty(exports, "CovidInfoPage", {
  enumerable: true,
  get: function get() {
    return _CovidInfoPage["default"];
  }
});
Object.defineProperty(exports, "OrderSetupPage", {
  enumerable: true,
  get: function get() {
    return _OrderSetupPage["default"];
  }
});
Object.defineProperty(exports, "PaymentPage", {
  enumerable: true,
  get: function get() {
    return _PaymentPage["default"];
  }
});
Object.defineProperty(exports, "ProcessingPaymentPage", {
  enumerable: true,
  get: function get() {
    return _b_ProcessingPaymentPage["default"];
  }
});
Object.defineProperty(exports, "BookingErrorPage", {
  enumerable: true,
  get: function get() {
    return _BookingErrorPage["default"];
  }
});
Object.defineProperty(exports, "BookingConfirmedPage", {
  enumerable: true,
  get: function get() {
    return _BookingConfirmedPage["default"];
  }
});
Object.defineProperty(exports, "EmptyOrdersPage", {
  enumerable: true,
  get: function get() {
    return _EmptyOrdersPage["default"];
  }
});
Object.defineProperty(exports, "OrdersPage", {
  enumerable: true,
  get: function get() {
    return _OrdersPage["default"];
  }
});
Object.defineProperty(exports, "TicketPage", {
  enumerable: true,
  get: function get() {
    return _TicketPage["default"];
  }
});
Object.defineProperty(exports, "TicketBoardingPassPage", {
  enumerable: true,
  get: function get() {
    return _TicketBoardingPassPage["default"];
  }
});
Object.defineProperty(exports, "TicketNotFoundPage", {
  enumerable: true,
  get: function get() {
    return _TicketNotFoundPage["default"];
  }
});
Object.defineProperty(exports, "WelcomePage", {
  enumerable: true,
  get: function get() {
    return _WelcomePage["default"];
  }
});
Object.defineProperty(exports, "ForgotPasswordLinkSentPage", {
  enumerable: true,
  get: function get() {
    return _ForgotPasswordLinkSentPage["default"];
  }
});
Object.defineProperty(exports, "ForgotPasswordPage", {
  enumerable: true,
  get: function get() {
    return _ForgotPasswordPage["default"];
  }
});
Object.defineProperty(exports, "LoginPage", {
  enumerable: true,
  get: function get() {
    return _LoginPage["default"];
  }
});
Object.defineProperty(exports, "LoggingInPage", {
  enumerable: true,
  get: function get() {
    return _LoggingInPage["default"];
  }
});
Object.defineProperty(exports, "SignUpPage", {
  enumerable: true,
  get: function get() {
    return _SigningUpPage["default"];
  }
});
Object.defineProperty(exports, "SignUpOkPage", {
  enumerable: true,
  get: function get() {
    return _SignUpOkPage["default"];
  }
});
Object.defineProperty(exports, "SettingsPage", {
  enumerable: true,
  get: function get() {
    return _SettingsPage["default"];
  }
});
Object.defineProperty(exports, "LanguageSettingsPage", {
  enumerable: true,
  get: function get() {
    return _LanguageSettingsPage["default"];
  }
});
Object.defineProperty(exports, "EditPassengersPage", {
  enumerable: true,
  get: function get() {
    return _EditPassengersPage["default"];
  }
});
Object.defineProperty(exports, "EditPassengerPopup", {
  enumerable: true,
  get: function get() {
    return _EditPassengerPopup["default"];
  }
});
Object.defineProperty(exports, "AddPassengerPopup", {
  enumerable: true,
  get: function get() {
    return _AddPassengerPopup["default"];
  }
});
Object.defineProperty(exports, "BetaOnboardingCarousselPage", {
  enumerable: true,
  get: function get() {
    return _BetaOnboardingCarousselPage["default"];
  }
});
Object.defineProperty(exports, "BetaOnboardingWaitingPage", {
  enumerable: true,
  get: function get() {
    return _BetaOnboardingWaitingPage["default"];
  }
});
exports.Router = exports.assets = void 0;

var _reactRouterDom = require("react-router-dom");

var _boy = _interopRequireDefault(require("./assets/boy.svg"));

var _girl = _interopRequireDefault(require("./assets/girl.svg"));

var _loadingImage = _interopRequireDefault(require("./assets/loading-image.gif"));

var _tick = _interopRequireDefault(require("./assets/tick.svg"));

var _bookingPending = _interopRequireDefault(require("./assets/booking-pending.svg"));

var _tire = _interopRequireDefault(require("./assets/tire.svg"));

var _decor = _interopRequireDefault(require("./components/01_atoms/Mountains/assets/decor.svg"));

var _fenetreSlim = _interopRequireDefault(require("./components/01_atoms/Mountains/assets/fenetre-slim.png"));

var _Colors = require("./components/00_environment/Colors");

Object.keys(_Colors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Colors[key];
    }
  });
});

var _Fonts = require("./components/00_environment/Fonts");

Object.keys(_Fonts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Fonts[key];
    }
  });
});

var _BlockWithLeftIcon = _interopRequireDefault(require("./components/01_atoms/BlockWithLeftIcon"));

var _Bottom = _interopRequireDefault(require("./components/01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("./components/01_atoms/Button"));

var _ClosableInput = _interopRequireDefault(require("./components/01_atoms/ClosableInput"));

var _Container = _interopRequireDefault(require("./components/01_atoms/Container"));

var _Divider = _interopRequireDefault(require("./components/01_atoms/Divider"));

var _Element = _interopRequireDefault(require("./components/01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("./components/01_atoms/ElementGroup"));

var _HighligthedText = _interopRequireDefault(require("./components/01_atoms/HighligthedText"));

var _Icon = _interopRequireDefault(require("./components/01_atoms/Icon"));

var _KeyValueElement = _interopRequireDefault(require("./components/01_atoms/KeyValueElement"));

var _LinkButton = _interopRequireDefault(require("./components/01_atoms/LinkButton"));

var _ListSelect = _interopRequireDefault(require("./components/01_atoms/ListSelect"));

var _LoadingPlaceHolder = _interopRequireDefault(require("./components/01_atoms/LoadingPlaceHolder"));

var _Page = _interopRequireDefault(require("./components/01_atoms/Page"));

var _PaymentIcon = _interopRequireDefault(require("./components/01_atoms/PaymentIcon"));

var _PlaceHolderElement = _interopRequireDefault(require("./components/01_atoms/PlaceHolderElement"));

var _ResponsivePage = _interopRequireDefault(require("./components/01_atoms/ResponsivePage"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("./components/01_atoms/RightPaneWidgetFrame"));

var _Spacer = _interopRequireDefault(require("./components/01_atoms/Spacer"));

var _SquaredText = _interopRequireDefault(require("./components/01_atoms/SquaredText"));

var _Subtitle = _interopRequireDefault(require("./components/01_atoms/Subtitle"));

var _Title = _interopRequireDefault(require("./components/01_atoms/Title"));

var _TitleBlock = _interopRequireDefault(require("./components/01_atoms/TitleBlock"));

var _TitledContainer = _interopRequireDefault(require("./components/01_atoms/TitledContainer"));

var _Top = _interopRequireDefault(require("./components/01_atoms/Top"));

var _TopBar = _interopRequireDefault(require("./components/01_atoms/TopBar"));

var _AddPassengerRightPane = _interopRequireDefault(require("./components/02_molecules/AddPassengerRightPane"));

var _AddPassengerWidget = _interopRequireDefault(require("./components/02_molecules/AddPassengerWidget"));

var _AddressFormComponent = _interopRequireDefault(require("./components/02_molecules/AddressFormComponent"));

var _BillingDetailsWidget = _interopRequireDefault(require("./components/02_molecules/BillingDetailsWidget"));

var _BookingForm = _interopRequireDefault(require("./components/02_molecules/BookingForm"));

var _CitySelectionWidget = _interopRequireDefault(require("./components/02_molecules/CitySelectionWidget"));

var _CovidInfoWidget = _interopRequireDefault(require("./components/02_molecules/CovidInfoWidget"));

var _DateSelectionComponent = _interopRequireDefault(require("./components/02_molecules/DateSelectionComponent"));

var _DateSelectionWidget = _interopRequireDefault(require("./components/02_molecules/DateSelectionWidget"));

var _DefaultScreen = _interopRequireDefault(require("./components/02_molecules/DefaultScreen"));

var _EditPassengerForm = _interopRequireDefault(require("./components/02_molecules/EditPassengerForm"));

var _EditPassengerFormUI = _interopRequireDefault(require("./components/02_molecules/EditPassengerFormUI"));

var _HomeTopBar = _interopRequireDefault(require("./components/02_molecules/HomeTopBar"));

var _LoadingScreen = _interopRequireDefault(require("./components/02_molecules/LoadingScreen"));

var _OrderPriceDetails = _interopRequireDefault(require("./components/02_molecules/OrderPriceDetails"));

var _PassengerDetails = _interopRequireDefault(require("./components/02_molecules/PassengerDetails"));

var _PlaceHolder = _interopRequireDefault(require("./components/02_molecules/PlaceHolder"));

var _PopupField = _interopRequireDefault(require("./components/02_molecules/PopupField"));

var _PopupScreen = _interopRequireDefault(require("./components/02_molecules/PopupScreen"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("./components/02_molecules/ResponsiveCentralPaneWrapper"));

var _RidesList = _interopRequireDefault(require("./components/02_molecules/RidesList"));

var _RidesListItem = _interopRequireDefault(require("./components/02_molecules/RidesListItem"));

var _SeatMatrix = _interopRequireDefault(require("./components/02_molecules/SeatMatrix"));

var _SeatMatrixFloorSelector = _interopRequireDefault(require("./components/02_molecules/SeatMatrixFloorSelector"));

var _SeatMatrixLegend = _interopRequireDefault(require("./components/02_molecules/SeatMatrixLegend"));

var _SeatSelectionWidget = _interopRequireDefault(require("./components/02_molecules/SeatSelectionWidget"));

var _SelectedPassengers = _interopRequireDefault(require("./components/02_molecules/SelectedPassengers"));

var _TicketDetails = _interopRequireDefault(require("./components/02_molecules/TicketDetails"));

var _TicketDetailsContent = _interopRequireDefault(require("./components/02_molecules/TicketDetailsContent"));

var _TripPriceDetails = _interopRequireDefault(require("./components/02_molecules/TripPriceDetails"));

var _TripSeatDetails = _interopRequireDefault(require("./components/02_molecules/TripSeatDetails"));

var _BoardingPass = _interopRequireDefault(require("./components/03_organisms/BoardingPass"));

var _SignInOrSignUpPageUI = _interopRequireDefault(require("./components/03_organisms/SignInOrSignUpPageUI"));

var _BookingFormPage = _interopRequireDefault(require("./components/04_pages/book/01_BookingFormPage"));

var _b_DateSelectionPopup = _interopRequireDefault(require("./components/04_pages/book/01b_DateSelectionPopup"));

var _GenericTripsListPage = _interopRequireDefault(require("./components/04_pages/book/02_GenericTripsListPage"));

var _GenericTripsDetailsPage = _interopRequireDefault(require("./components/04_pages/book/03_GenericTripsDetailsPage"));

var _b_GenericTripSeatSelectionPage = _interopRequireDefault(require("./components/04_pages/book/03b_GenericTripSeatSelectionPage"));

var _c_GenericStopsPage = _interopRequireDefault(require("./components/04_pages/book/03c_GenericStopsPage"));

var _PassengerDetailsPage = _interopRequireDefault(require("./components/04_pages/book/04_PassengerDetailsPage"));

var _PassengerDetailsAddPage = _interopRequireDefault(require("./components/04_pages/book/04_PassengerDetailsAddPage"));

var _BillingDetailsPage = _interopRequireDefault(require("./components/04_pages/book/05_BillingDetailsPage"));

var _CovidInfoPage = _interopRequireDefault(require("./components/04_pages/book/06_CovidInfoPage"));

var _OrderSetupPage = _interopRequireDefault(require("./components/04_pages/book/07_OrderSetupPage"));

var _PaymentPage = _interopRequireDefault(require("./components/04_pages/book/08_PaymentPage"));

var _b_ProcessingPaymentPage = _interopRequireDefault(require("./components/04_pages/book/08b_ProcessingPaymentPage"));

var _BookingErrorPage = _interopRequireDefault(require("./components/04_pages/book/09_BookingErrorPage"));

var _BookingConfirmedPage = _interopRequireDefault(require("./components/04_pages/book/10_BookingConfirmedPage"));

var _EmptyOrdersPage = _interopRequireDefault(require("./components/04_pages/EmptyOrdersPage"));

var _OrdersPage = _interopRequireDefault(require("./components/04_pages/OrdersPage"));

var _TicketPage = _interopRequireDefault(require("./components/04_pages/TicketPage"));

var _TicketBoardingPassPage = _interopRequireDefault(require("./components/04_pages/TicketBoardingPassPage"));

var _TicketNotFoundPage = _interopRequireDefault(require("./components/04_pages/TicketNotFoundPage"));

var _WelcomePage = _interopRequireDefault(require("./components/04_pages/WelcomePage"));

var _ForgotPasswordLinkSentPage = _interopRequireDefault(require("./components/04_pages/login/ForgotPasswordLinkSentPage"));

var _ForgotPasswordPage = _interopRequireDefault(require("./components/04_pages/login/ForgotPasswordPage"));

var _LoginPage = _interopRequireDefault(require("./components/04_pages/login/LoginPage"));

var _LoggingInPage = _interopRequireDefault(require("./components/04_pages/login/LoggingInPage"));

var _SigningUpPage = _interopRequireDefault(require("./components/04_pages/login/SigningUpPage"));

var _SignUpOkPage = _interopRequireDefault(require("./components/04_pages/login/SignUpOkPage"));

var _SettingsPage = _interopRequireDefault(require("./components/04_pages/settings/SettingsPage"));

var _LanguageSettingsPage = _interopRequireDefault(require("./components/04_pages/settings/LanguageSettingsPage"));

var _EditPassengersPage = _interopRequireDefault(require("./components/04_pages/settings/EditPassengersPage"));

var _EditPassengerPopup = _interopRequireDefault(require("./components/04_pages/settings/EditPassengerPopup"));

var _AddPassengerPopup = _interopRequireDefault(require("./components/04_pages/settings/AddPassengerPopup"));

var _BetaOnboardingCarousselPage = _interopRequireDefault(require("./components/04_pages/onboarding/BetaOnboardingCarousselPage"));

var _BetaOnboardingWaitingPage = _interopRequireDefault(require("./components/04_pages/onboarding/BetaOnboardingWaitingPage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Assets
// FIXME: Find a better way?
function getImagesToPreload() {
  console.log('getImagesToPreload() --> ', [_decor["default"], _fenetreSlim["default"]]);
  return [_decor["default"], _fenetreSlim["default"]];
} // //////////////////////////////////////////////////////////////////////////////
// Environment


// //////////////////////////////////////////////////////////////////////////////
var assets = {
  boy: _boy["default"],
  girl: _girl["default"],
  loadingImage: _loadingImage["default"],
  tick: _tick["default"],
  bookingPending: _bookingPending["default"],
  tire: _tire["default"]
}; // Export router to avoid getting false errors 'You should not use <Link> outside a <Router>'

exports.assets = assets;

var isNative = function isNative() {
  return window && window.ReactNativeWebView;
};

var Router = isNative() ? _reactRouterDom.HashRouter : _reactRouterDom.BrowserRouter;
exports.Router = Router;